export const styleHeaderCard = {
  focused: {
    m: 2,
    width: '75px',
    padding: '10px',
    border: ' 2px solid #2680b1',
    borderRadius: '15px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  normal: {
    m: 2,
    width: '75px',
    padding: '10px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}
